import React from 'react';

function wrapperStyle() {
  const style = {};
  return style;
}

function messageStyle({ constants, color, styles }) {
  const style = {
    ...styles.fontStyle,
    fontSize: constants.KEY_THANK_YOU_MESSAGE_FONT_SIZE,
    color: color.grey['600'],
    marginBottom: constants.KEY_THANK_YOU_MESSAGE_MARGIN_BOTTOM,
    paddingRight: constants.KEY_THANK_YOU_MESSAGE_PADDING_HORIZONTAL,
    paddingLeft: constants.KEY_THANK_YOU_MESSAGE_PADDING_HORIZONTAL,
    textAlign: 'center'
  };

  return style;
}

function restartStyle({ constants, color, styles }) {
  const style = {
    ...styles.fontStyle,
    height: constants.KEY_THANK_YOU_BUTTON_HEIGHT,
    fontSize: constants.KEY_THANK_YOU_BUTTON_FONT_SIZE,
    lineHeight: `${constants.KEY_THANK_YOU_BUTTON_HEIGHT}px`,
    borderRadius: constants.KEY_THANK_YOU_BUTTON_HEIGHT / 2,
    backgroundColor: color.white,
    fontWeight: 900,
    color: color.grey['600'],
    paddingRight: constants.KEY_THANK_YOU_BUTTON_PADDING_HORIZONTAL,
    paddingLeft: constants.KEY_THANK_YOU_BUTTON_PADDING_HORIZONTAL,
    border: `1px solid ${color.grey['400']}`
  };

  return style;
}

export default props => (
  <div style={wrapperStyle(props)}>
    <div style={messageStyle(props)}>
      {props.text.SIGN_THANK_YOU}
    </div>
    <div style={props.styles.centerStyle}>
      <div
        style={restartStyle(props)}
        onClick={props.redirect}
        onKeyPress={props.redirect}
        tabIndex={0}
        role="button"
      >
        Restart
      </div>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/KeyThankYou/index.js